module.exports = __webpack_public_path__ + "static/media/210623_guidance_5.454c7eed.png";